// extracted by mini-css-extract-plugin
export default {"dialog_group_container":"CreateEntityModelDialog_dialog_group_container__Z403I","subtitle":"CreateEntityModelDialog_subtitle__u9eKM"};